import React from 'react';
import styled from 'styled-components';
import { BaseConfetti } from 'elements/confetti/confetti.styles'
import { layout } from 'styles/layout'

export const Confetti1 = styled(BaseConfetti).attrs({
  width: 25,
  height: 22,
  viewBox: '0 0 25 22',
  children: <path xmlns="http://www.w3.org/2000/svg" d="M3.88488 0.944814L0.897949 21.7446L24.7926 3.94753L3.88488 0.944814Z" fill="#80D1CD"/>
})`
  top: -10%;
  left: 15%;

  @media all and (min-width: ${layout.subLg}) {
    top: 20%;
  }
`

export const Confetti2 = styled(BaseConfetti).attrs({
  width: 25,
  height: 27,
  viewBox: '0 0 25 27',
  children: <path xmlns="http://www.w3.org/2000/svg" d="M21.7139 26.8948L24.6127 10.7408L19.2498 2.95779L3.18219 -5.57008e-05L0.223875 16.0674L5.58668 23.8504L21.7139 26.8948Z" fill="#FFDF6E"/>
})`
  top: 0;
  right: 40%;

  @media all and (min-width: ${layout.subLg}) {
    top: 10%;
    right: 5%;
  }
`

export const Confetti3 = styled(BaseConfetti).attrs({
  width: 31,
  height: 18,
  viewBox: '0 0 31 18',
  children: <path xmlns="http://www.w3.org/2000/svg" d="M28.9262 9.16786L19.0504 16.4396L2.73617 1.61247L21.7911 2.6832L28.9262 9.16786Z" stroke="#FF7062" strokeWidth="2.09953"/>
})`
  top: -15%;
  right: 5%;

  @media all and (min-width: ${layout.subLg}) {
    top: -5%;
    right: 55%;
  }
`
